import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import useBootstrapOrgInfo from '../../../../hooks/bootstrapOrgInfo.hook';
import EarlyAccessPageHeading from './EarlyAccessPageHeading';
import TenantPickerLayout from '../../Layout/TenantPickerLayout';
import Logo from '../../Logo/Logo';
import useStyles from './EarlyAccessPage.styles';
import {
  getEarlyAccessShouldRenderErrorScreen,
  getEarlyAccessShouldRenderSuccessScreen,
} from '../../../../store/selectors/EarlyAccessPageState';
import EarlyAccessButtons from './EarlyAccessButtons';
import HCPCountryStateAndOrgForm from '../../../CountryStateAndOrg/HCPCountryStateAndOrgForm';
import EarlyAccessDomain from './EarlyAccessDomain';

const EarlyAccessPage = () => {
  const { classes } = useStyles();
  const renderErrorState = useSelector(getEarlyAccessShouldRenderErrorScreen);
  const renderSuccessState = useSelector(
    getEarlyAccessShouldRenderSuccessScreen,
  );
  useBootstrapOrgInfo();

  return (
    <TenantPickerLayout>
      <header>
        <Logo />
        <EarlyAccessPageHeading />
      </header>
      <main>
        <form className={classes.form}>
          {!renderSuccessState && (
            <>
              <HCPCountryStateAndOrgForm />
              <EarlyAccessDomain />
            </>
          )}

          {renderSuccessState && (
            <Typography variant="body2">
              <FormattedMessage id="earlyAccess.magicLink.success" />
            </Typography>
          )}
          {!renderSuccessState && (
            <EarlyAccessButtons
              canSubmit={!renderErrorState && !renderSuccessState}
            />
          )}
        </form>
      </main>
    </TenantPickerLayout>
  );
};

export default EarlyAccessPage;
